import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendPlane = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 27,
	height: 27,
	viewBox: "0 0 27 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M25.0196 11.2731L2.89961 0.213083C2.54928 0.0369704 2.15491 -0.0322779 1.76554 0.0139489C1.37616 0.0601758 1.00897 0.219838 0.709612 0.473083C0.409502 0.726518 0.190665 1.06272 0.0804061 1.43973C-0.0298525 1.81674 -0.0266505 2.21788 0.0896124 2.59308L3.00961 12.0631H13.3596C13.6248 12.0631 13.8792 12.1684 14.0667 12.356C14.2543 12.5435 14.3596 12.7979 14.3596 13.0631C14.3596 13.3283 14.2543 13.5827 14.0667 13.7702C13.8792 13.9577 13.6248 14.0631 13.3596 14.0631H3.00961L0.0896124 23.5331C-0.00273799 23.8322 -0.0235815 24.1488 0.0287589 24.4575C0.0810994 24.7661 0.205162 25.0582 0.390964 25.3101C0.576766 25.5621 0.819117 25.7669 1.09852 25.9081C1.37792 26.0493 1.68656 26.1229 1.99961 26.1231C2.31189 26.1243 2.62012 26.0524 2.89961 25.9131L25.0196 14.8531C25.3524 14.6872 25.6324 14.4318 25.8281 14.1156C26.0238 13.7994 26.1275 13.4349 26.1275 13.0631C26.1275 12.6912 26.0238 12.3267 25.8281 12.0105C25.6324 11.6943 25.3524 11.439 25.0196 11.2731Z",
		fill: "#4F31FF",
		fillOpacity: .44
	})
});
export default SvgSendPlane;
